<template>
  <router-link v-show="prevStep" :to="prevStep">‹ Back</router-link>
</template>

<script>
import steps from '../utils/browserHistory.js';

export default {
  name: 'ButtonBack',
  props: {
    currentStep: {
      type: String,
      required: true
    }
  },
  computed: {
    prevStep: function() {
      return steps.prevStep(this.currentStep)
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ButtonBack.vue